// Eskom PARCC — loading / error / empty state helpers.
//
// Every data page needs a consistent way to show "loading", "failed to load" and
// "nothing here". These wrap the existing `.card` / `.callout` / `.empty` styles
// so pages don't reinvent them. Presentational only.
import type { ReactNode } from 'react';

export function LoadingState({
  message = 'Loading…',
}: {
  message?: ReactNode;
}): React.JSX.Element {
  return (
    <div className="card" role="status" aria-live="polite">
      <div className="empty">{message}</div>
    </div>
  );
}

export function ErrorState({
  message = 'Something went wrong while loading this view.',
  detail,
  onRetry,
}: {
  message?: ReactNode;
  /** Optional secondary line, e.g. an error message. */
  detail?: ReactNode;
  /** When supplied, renders a "Try again" button. */
  onRetry?: () => void;
}): React.JSX.Element {
  return (
    <div className="callout" role="alert">
      <strong>{message}</strong>
      {detail !== undefined && <div className="small">{detail}</div>}
      {onRetry && (
        <div className="actions" style={{ marginTop: 12 }}>
          <button type="button" className="btn" onClick={onRetry}>
            Try again
          </button>
        </div>
      )}
    </div>
  );
}

export function EmptyState({
  message = 'No records to display.',
}: {
  message?: ReactNode;
}): React.JSX.Element {
  return (
    <div className="card">
      <div className="empty">{message}</div>
    </div>
  );
}
